module.exports = __webpack_public_path__ + "79464e32fc72a824c22e11ac2c07e44f.png";